enum SpecOutContactStatus {
    Pending = 10,
    Skipped = 20,
    Processing = 30,
}

export default SpecOutContactStatus;
